import { render } from "./Periods.vue?vue&type=template&id=1f1fa7e4"
import script from "./Periods.vue?vue&type=script&lang=js"
export * from "./Periods.vue?vue&type=script&lang=js"

import "./Periods.vue?vue&type=style&index=0&id=1f1fa7e4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__